import React from 'react'
import Modal from 'react-modal'
import {connect} from 'react-redux'
import {Table, Thead, Th, Tr, Td} from 'components/reactable'
import {eq} from 'lodash/lang'
import styles from './listSelect.scss'
import Input from './input'
import {dateFormatter} from 'lib/helpers'
import underscore from 'underscore'
import i18n from 'lib/i18n'
import uuidv4 from 'uuid/v4'

const _ = i18n('clients')

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        zIndex: 2
    },
    content: {
        position: 'relative',
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '0',
    },
}

export default class IbansListSelect extends React.Component {
    static propTypes = {
        data: React.PropTypes.array,
    }

    constructor(props) {
        super(props)
        this.state = { modalIsOpen: false }
    }

    getIcon() {
        try {
            return require(`resources/images/a-trash_1x_ovbBlue.svg`)
        } catch(err) {
            return require(`resources/images/icn-no-result.svg`)
        }
    }


    openModal() {
        this.setState({modalIsOpen: !this.state.modalIsOpen})
    }

    handleAddFieldButton() {
        const data = this.props.data
        
        this.openModal()
        data.addField({IBAN: "", BIC: "", uniqueId: uuidv4()})
    }

    removeItemFromList( itemUniqueId ) {
        const data = this.props.data

        Object.keys(data).map((dataKey) => {
            if( data[dataKey] && data[dataKey] !== undefined && data[dataKey].uniqueId.value === itemUniqueId ) {
                data.removeField(dataKey)
            }
        })
    }

    removeItem() {
        const data = this.props.data
        data.removeField();
    }

    modalContentPopup() {
        const data = this.props.data

        let lastData = data.slice(-1)[0]
        let errorData = false

        if (lastData != undefined) {
            if (lastData.IBAN.error != undefined) {
                errorData = true
            }
            else {
                errorData = false
            }
        }

        return (
            <div className={styles.clientModalContent}>
                <span className={styles.title}>{_("addAccount")}</span>
                <label>{_('iban')}</label>
                {lastData != undefined && <input type="text" {...lastData.IBAN} /> }
                <div className={ styles.error }> {lastData != undefined && lastData.IBAN.error && lastData.IBAN.touched && lastData.IBAN.error } </div>
                <label>{_('bic')}</label>
                {lastData != undefined && <input type="text" {...lastData.BIC} /> }
                <div className={ styles.error }> {lastData != undefined && lastData.BIC.error && lastData.BIC.touched && lastData.BIC.error } </div>
                <div className={styles.clientModalButtons}>
                    <input
                        onClick={() => {
                            this.openModal()
                            this.removeItem()
                        }}
                        type="button"
                        className={styles.cancel}
                        value={_("cancel")}
                    />
                    <input
                        onClick={() => this.openModal()}
                        type="button"
                        className={styles.next + " " + (!errorData && styles.enabled) }
                        value={_("clientAdd")}
                        disabled={errorData}
                    />
                </div>
            </div>
        )
    }

    render() {
        const data  = this.props.data
        const modalIsOpen = this.state.modalIsOpen

        return (
            <div className={styles.moduleSection}>
                <div className={styles.clientsTableContainer}>
                    {!underscore.isEmpty(data) && underscore.isArray(data) && (data[0] !== 'Too many rows') &&
                    <Table
                        className={styles.table}
                        itemsPerPage={50}
                        topPagination=""
                        filterable={[]}
                        sortable={[
                            "BIC.value",
                            "IBAN.value",
                        ]}
                        defaultSort={{
                            column: 'BIC.value',
                            direction: 'asc',
                        }}
                    >
                        <Thead>
                        <Th column="BIC.value">
                            <strong>{_('bic')}</strong>
                        </Th>
                        <Th column="IBAN.value">
                            <strong>{_('iban')}</strong>
                        </Th>
                        <Th column="checkEmail">
                            <strong></strong>
                        </Th>
                        </Thead>
                        { data.map((item, key) =>
                            <Tr className="centered" key={item.uniqueId.value}>
                                <Td column="BIC.value">{item.BIC.value}</Td>
                                <Td column="IBAN.value">{item.IBAN.value}</Td>
                                <Td column="checkEmail">
                                    <button type="button" className={styles.removeFieldsButton} onClick={event => {
                                        event.preventDefault()
                                        this.removeItemFromList(item.uniqueId.value)
                                    }}>
                                        <img src={this.getIcon()}/>
                                    </button>
                                </Td>
                            </Tr>
                        )
                        }
                    </Table>
                    }

                    <button type="button"
                            className={styles.addFieldButton}
                            onClick={() => {
                                this.handleAddFieldButton()
                            }}>+
                    </button>
                </div>
                <Modal
                    isOpen={modalIsOpen}
                    style={customStyles}
                    contentLabel="Modal"
                >
                    {this.modalContentPopup()}
                </Modal>
            </div>


        )
    }
}



// WEBPACK FOOTER //
// ./components/ibansListSelect.jsx